import React, { CSSProperties, JSX, ReactElement, useContext } from "react";
import { GetServerSideProps } from "next";
import Head from "next/head";
import { StructuredText } from "react-datocms";
import {
  META_TITLE,
  CANONICAL_URL_BASE,
  META_DESCRIPTION,
} from "constants/meta";
import { LogContext } from "context/log";
import TopHeaderLayout from "components/Layout/TopHeaderLayout/TopHeaderLayout";
import { PAGE_TYPE_ENUM } from "@pepdirect/v3/types";
import { generatePageId } from "@pepdirect/v3/helpers/analyticsLogger";
import { FaqPageQueryQuery, getSdk } from "services/datocms/generated";
import { createDatoClient } from "services/datocms";
import st from "./st.module.scss";

interface FAQPageProps {
  faqPageData: FaqPageQueryQuery["faqPage"];
}

export const getServerSideProps: GetServerSideProps<FAQPageProps> = async ({
  preview,
}) => {
  const data = await getSdk(createDatoClient(preview)).FaqPageQuery();

  return {
    props: {
      faqPageData: data.faqPage,
    },
  };
};

function FAQ({ faqPageData }: FAQPageProps): JSX.Element {
  const { useLogPageView } = useContext(LogContext);

  const metaTitle = `FAQ - ${META_TITLE}`;
  const metaUrl = `${CANONICAL_URL_BASE}/faq`;

  useLogPageView({
    pageType: PAGE_TYPE_ENUM.support,
    pageCategory: undefined,
    pageTitle: metaTitle,
    id: generatePageId("faq"),
  });

  return (
    <div className={st.wrapper}>
      <Head>
        <title>{metaTitle}</title>
        <meta name="og:title" content={metaTitle} key="og:title" />
        <link rel="canonical" href={metaUrl} />
        <meta name="og:url" content={metaUrl} key="og:url" />
        <meta name="description" content={META_DESCRIPTION} key="description" />
        <meta
          name="og:description"
          content={META_DESCRIPTION}
          key="og:description"
        />
      </Head>
      {/* <section className={st["mission--section-3"]}>
        <h2>FAQs</h2>
        <div className={st["mission--faq-subtitle-section"]}>
          <p className={st["mission--faq-subtitle"]}>
            Teamzone is here to keep you stocked and put your mind at ease!
          </p>
          {FAQText.map((header, index) => (
            <div key={index}>
              <a href={`#${header.id}`} className={st["mission--category"]}>
                {header.headerText}
              </a>
            </div>
          ))}
        </div>
        {FAQText.map((faq, index) => (
          <div key={index} className={st.faqContainer} id={faq.id}>
            <h3 className={st["mission--header-text"]}>{faq.headerText}</h3>
            <div>{renderQuestionAnswer(faq.faq)}</div>
          </div>
        ))}
      </section> */}

      <StructuredText
        data={faqPageData?.faqText}
        renderBlock={({ record }) => {
          if (record.__typename === "RichTextRecord") {
            return (
              <div
                key={record.id}
                id={record.htmlId ?? undefined}
                className={st.scrollMargin}
                style={{
                  textAlign: (record.textAlignment ||
                    "left") as CSSProperties["textAlign"],
                  color: record.textColor?.hex,
                  backgroundColor: record.backgroundColor?.hex,
                }}
              >
                <StructuredText data={record.text} />
              </div>
            );
          }
          return null;
        }}
      />
    </div>
  );
}

// eslint-disable-next-line react/display-name
FAQ.getLayout = (page: ReactElement) => <TopHeaderLayout page={page} />;

export default FAQ;
